export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/common/icon-sort-like-710d098ceb7d36020ad49379d5109819.svg";